'use strict';

angular.module('contactsController', [])
.controller('ContactsController', ['$scope', '$rootScope', '$log', '$q','AgentService',
    function ($scope, $rootScope, $log, $q, AgentService) {    
    
    //Check auth credentials
    var currentUser = $rootScope.currentUser
    , ekey = currentUser.authdata
    , name = currentUser.name
    , agencies = currentUser.agencies
    , today = moment().unix()
    ;

    $scope.title = 'My Team';

    $scope.agencyContacts = [];

    angular.forEach(agencies, function (agency) {
        AgentService.agencyContacts(agency.identifier).then(function(response) {
          contacts = response.result; 
          angular.forEach(contacts, function (contact) {
            $scope.agencyContacts.push(contact);
          });
        });
    });


}]);